import logoImg from "@/assets/ramautor-team-logo.webp";

export function LogoMark({ className = "h-10 w-10" }) {
  return <img src={logoImg} alt="The Ramautor Team" className={`${className} w-auto`} />;
}

export default function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark className="h-9" />
      <span className="hidden leading-tight sm:block">
        <span
          className={`block font-display text-sm font-extrabold tracking-[0.2em] ${
            light ? "text-white" : "text-zinc-900 dark:text-white"
          }`}
        >
          52-461 BEECHWOOD PLACE
        </span>
        <span className="block text-[10px] uppercase tracking-[0.28em] text-bronze">
          Royal LePage Wolle Realty
        </span>
      </span>
    </span>
  );
}
